export enum AuctionState {
  Live,
  CompletedByTime,
  CompletedByDirectPurchase,
  NotSoldByReservePrice,
  Claimed,
}

export enum PoolState {
  Live,
  Close,
}
